var map = {
	"./OauthCallback.js": "82b0",
	"./about.js": "f286",
	"./active.js": "428de",
	"./balance.js": "913a",
	"./download.js": "b8d1",
	"./exchangePurchase.js": "1003",
	"./home.js": "9f25",
	"./login.js": "6b6c",
	"./logistics.js": "428d",
	"./newCustomers.js": "72f8",
	"./newproduct.js": "707a",
	"./order.js": "3697",
	"./pointsMall.js": "5283",
	"./priceReview.js": "0b58",
	"./product.js": "4449",
	"./productdetails.js": "5822",
	"./question.js": "9d76",
	"./searchPage.js": "327e",
	"./shopCart.js": "342e",
	"./user.js": "2963"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d56b";